module.exports = __webpack_public_path__ + "static/the-impatient-list-199a7a1b2f73f241f605e17d40f47713.jpg";